import { useContext, useState } from 'react';

import Progress from "@mui/material/CircularProgress";
import { Button, Divider } from "@mui/material";
import AppContext from '../../../context/AppProvider';
import { useEffect } from 'react';
import { useEditConfigsMutation } from '../../../services/configApi';
import BasicModalConfirmation from '../../../components/basicModalConfirmation';
import BasicModalInformation from '../../../components/basicModalInformation';
import TextField from '@mui/material/TextField';

import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import CreateOutlinedIcon from '@mui/icons-material/CreateOutlined';

import ResourcesPanel from './resources/ResourcesPanel';

import cancelIcon from '../../../img/close-icon-button.svg';
import SystemMessage from './honeycombMessage/SystemMessage';
import Distribution from './honeycombMessage/Distribution';

// HELPERS
function parseBooleans(config) {
  let aux = config.map(conf => {
    if (conf.value == "true" || conf.value == "false") {
      return { ...conf, value: conf.value === "true" }
    } else {
      return conf
    }
  })
  return aux;
}

function AfkTimeHoursComp({ afkHours, setConfig }) {
  const [canEdit, setCanEdit] = useState(false);

  function isValidAfkHours(afkHoursEdited) {
    let afkTimeHoursParsed = Number(afkHoursEdited);
    if (afkHoursEdited == "" || isNaN(afkTimeHoursParsed) || !Number.isInteger(afkTimeHoursParsed) || afkTimeHoursParsed <= 0) {
      return false;
    }
    return true;
  }

  function EditableHours() {
    const [afkTimeHours, setAfkTimeHours] = useState(afkHours?.value);
    const [confirmationModalIsOpen, setConfirmationModalIsOpen] = useState(false);
    const [informationModalIsOpen, setInformationModalIsOpen] = useState(false);
    const [updateConfig] = useEditConfigsMutation();

    function onChangeHandler(e) {
      setAfkTimeHours(e.target.value)
    }

    const handleSaveClick = () => {
      setConfirmationModalIsOpen(true);
    }

    const handleUserConfirmation = async () => {
      if (!isValidAfkHours(afkTimeHours)) {
        setConfirmationModalIsOpen(false);
        setInformationModalIsOpen(true);
        return;
      }
    let updatedConfig
    try {
        updatedConfig = await updateConfig([{ id: afkHours.id, value: afkTimeHours }]).unwrap();
    } catch (error) {
      console.log("getAvailableJobs_2 error: " + JSON.stringify(error))
      if(error.status == 401) return; //error managed on baseQueryWithReauth 
      throw error
    }
      let parsedBooleans = parseBooleans(updatedConfig);
      setCanEdit(false)
      setConfig(parsedBooleans)
    }

    const handleUserRejection = () => {
      setAfkTimeHours(afkHours?.value);
      setCanEdit(false);
    }

    return (
      <>
        <TextField
          id="standard-basic"
          variant="outlined"
          type="number"
          sx={{ width: "100px" }}
          InputProps={{ inputProps: { min: 0 } }}
          value={afkTimeHours}
          onChange={onChangeHandler}
        />

        <Button variant="text" onClick={() => {
          handleSaveClick()
        }} > <SaveOutlinedIcon sx={{ margin: "0 0.25em 0 0" }} /> Save</Button>

        <Button className="btn-cancel-form" onClick={handleUserRejection}>
          <img src={cancelIcon} alt='Cancel Icon' height='18px' style={{ marginRight: '0.25em' }} />
          <span style={{ color: ' var(--amber) ' }}>Cancel</span>
        </Button>

        <BasicModalInformation
          open={informationModalIsOpen}
          handleClose={() => setInformationModalIsOpen(false)}
          title={"Time must be Positive And Integer"}
        />

        <BasicModalConfirmation
          open={confirmationModalIsOpen}
          onClick={handleUserConfirmation}
          onCloseClick={handleUserRejection}
          handleClose={() => setConfirmationModalIsOpen(false)}
          title={"Are you sure you want to change the IDLE time?"} confirmLabel="Yes" cancelLabel="No"
        />

      </>
    )
  }

  const NonEditableHours = () =>
  (
    <>
      <div style={{ width: 100, fontSize: "1.3em" }}>
        {afkHours.value ? afkHours.value + " Hours" : "Loading"}
      </div>

      <Button variant="text" onClick={() => setCanEdit(true)} > <CreateOutlinedIcon sx={{ margin: "0 0.25em 0 0", color:'var(--amber)' }} /> Edit </Button>
    </>
  )


  return (
    <>
      {canEdit ? <EditableHours /> : <NonEditableHours />}
    </>
  )
}

const GlobalSettings = () => {
  const [configState, setConfigState] = useState({});
  const [updateConfig] = useEditConfigsMutation();

  const [openConfirmation, setOpenConfirmation] = useState(null);
  const { config: AppSettings, setConfig } = useContext(AppContext);

  useEffect(() => {
    console.log("Initial config: ", AppSettings)
    if (AppSettings.length > 0) {
      const result = AppSettings.reduce((acc, item) => {
        acc[item.name] = Object.assign({}, item);
        return acc;
      }, {});
      setConfigState(result)
    }
  }, [AppSettings])

  const handleCancel = () => {
    if (AppSettings.length > 0) {
      const result = AppSettings.reduce((acc, item) => {
        acc[item.name] = Object.assign({}, item);
        return acc;
      }, {});
      setConfigState(result)
    }
    setOpenConfirmation(false)
  }

  const handleConfigSwitchChange = (config) => {
    setConfigState({ ...configState, [config.name]: config });
    setOpenConfirmation(config.name)// open confirmation now i used to indicate wich configuration is being updated and to open the confirmation modal
  }

  const handleSaveConfig = async () => {
  let updatedConfig
  try {
    updatedConfig = await updateConfig([configState[openConfirmation]]).unwrap() // open confirmation now i used to indicate wich configuration is being updated and to open the confirmation modal
  } catch (error) {
    console.log("handleSaveConfig error: " + JSON.stringify(error))
    if(error.status == 401) return; //error managed on baseQueryWithReauth 
    throw error
  }
    
    let parsedBooleans = parseBooleans(updatedConfig);
    setConfig(parsedBooleans)
  }  

  let ConfirmationMessage = ""

  if(openConfirmation === "enableJobClaiming"){
    ConfirmationMessage = `Are you sure you want to ${configState?.enableJobClaiming?.value ? "resume" : "stop"  } job claiming${!configState?.enableJobClaiming?.value ?" for all users?":"?"}`
  }else if(openConfirmation === "DisableDistributionForSwarm"){
    ConfirmationMessage = `Are you sure you want to ${configState?.DisableDistributionForSwarm?.value ? "stop" : "resume" } job claiming${configState?.DisableDistributionForSwarm?.value ? " for Swarms?" : "?"}`
  }else{
    ConfirmationMessage = `Are you sure you want to change this configuration?`
  }

  return (
    <>
      {
        <BasicModalConfirmation 
          open={Boolean(openConfirmation)} 
          onClick={handleSaveConfig} 
          onCloseClick={handleCancel} 
          handleClose={() => setOpenConfirmation(false)} 
          title={ConfirmationMessage} 
          confirmLabel="Yes" 
          cancelLabel="No" 
        />}
      <h3 style={{ margin: '0 0 1em 0' }} > Global Settings </h3>
      {(Object.keys(AppSettings)).length <= 0 ?
        <Progress />
        :
        (
          <>
            <section className="global-settings-section">
              <h4 style={{ margin: '0 0 1em 0' }} > HONEYCOMB </h4>

              <Divider style={{ margin: '0 0 1em 0' }} />
                <Distribution configState={configState} handleConfigSwitchChange={handleConfigSwitchChange}/>
              <Divider style={{ margin: '0 0 1em 0' }} />
              <SystemMessage />

            </section>

            <section className="global-settings-section" >
              <h4 style={{ margin: '0 0 1em 0' }} > TIMER SETTINGS </h4>

              <Divider style={{ margin: '0 0 1em 0' }} />

              <div className="global-settings-section-div">

                <div style={{ margin: '0 2em 0 0' }} >
                  <h4 style={{ fontWeight: '600', margin: '0 0 1em 0' }} >Even Distribution Group</h4>
                  <p style={{ margin: '0 0 1em 0' }} >Group bees together that have been idle for more than X hours for even distribution</p>
                </div>

                <div className="even-distribution-group-edit">
                  <AfkTimeHoursComp setConfig={setConfig} afkHours={configState?.afkTimeHours ?? {}} />
                </div>
              </div>
            </section>
          </>
        )}

      <section className="global-settings-section">
        <ResourcesPanel/>
      </section>
      
    </>
  );
};

export default GlobalSettings;
